import { store } from '@/store/store';
import { grupo_centro } from '@/shared/dtos/grupo_centro';
import {
    VuexModule,
    Mutation,
    getModule,
    Module,
    Action
} from 'vuex-module-decorators';
import { ssmHttpService } from '@/shared/services/http-service';
import { API } from '@/shared/api';

@Module({
    namespaced: true,
    name: 'grupo_centroModule',
    store,
    dynamic: true
})
class grupo_centroModule extends VuexModule {
    public grupo_centros: grupo_centro[] = [];
    public grupo_centro: grupo_centro = new grupo_centro();

    @Action({ commit: 'onGetgrupo_centros' })
    public async getgrupo_centros() {
        return await ssmHttpService.get(API.grupo_centro);
    }

    @Action({ commit: 'onGetgrupo_centro' })
    public async getgrupo_centro(id: any) {
        return await ssmHttpService.get(API.grupo_centro + '/' + id);
    }

    @Action
    public async guardargrupo_centro(grupo_centro: grupo_centro) {
        /*toJson() no existe pero existe en la extends de BaseDto*/
        return await ssmHttpService.post(API.grupo_centro, grupo_centro.toJson());
    }

    @Action
    public async modificargrupo_centro(grupo_centro: grupo_centro) {
        return await ssmHttpService.put(API.grupo_centro + '/' + grupo_centro.id, grupo_centro);
    }

    @Action
    public async eliminargrupo_centro(grupo_centro: grupo_centro) {
        return await ssmHttpService.delete(API.grupo_centro + '/' + grupo_centro.id, null, false);
    }

    @Mutation
    public onGetgrupo_centros(res: grupo_centro[]) {

        this.grupo_centros = res ? res.map((x) => new grupo_centro(x)) : []
    }

    @Mutation
    public onGetgrupo_centro(res: grupo_centro) {
        this.grupo_centro = new grupo_centro(res);
    }

}
export default getModule(grupo_centroModule);